// Phase 7 — Mugizh-admin Reports (static mockup) migrated to shadcn/Tailwind.
//
// No dispatch/API — hardcoded rows and options. UI only: antd DatePicker/Select/
// Table → the shared DateRangePicker + shadcn Select + shared DataTable, with a
// segmented Sales/Stocks/Customers tab row. The local report-type/option state is
// preserved (it only drives which mock columns/data render).
import React, { useEffect, useMemo, useState } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { DateRange } from 'react-day-picker';
import { PageHeader } from '../shared/page-header';
import { DataTable } from '../shared/data-table';
import { DateRangePicker } from '../Components/Reports/DateRangePicker';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'ui/select';
import { cn } from 'lib/utils';

const data = [
  { subCategory: 'Loren Ipsum', availableCount: '95' },
  { subCategory: 'Loren Ipsum', availableCount: '65' },
];

const customerData = [
  { name: 'Loren Ipsum', mobileNo: '9988776655' },
  { name: 'Loren Ipsum', mobileNo: '9988776655' },
];

const salesOptions = [
  { label: 'Sold Items(323) - 1,20,000', value: 'sold-323' },
  { label: 'Sold Items(1,20,000) - 3,00,000', value: 'sold-120000' },
];
const stocksOptions = [
  { label: 'Available(323)', value: 'available-323' },
  { label: 'Available(500)', value: 'available-500' },
];
const customerOptions = [
  { label: 'New User(154)', value: 'new-user' },
  { label: 'Premium User(204)', value: 'premium-user' },
];

const TABS = ['Sales', 'Stocks', 'Customers'];

const Report = () => {
  const [reportType, setReportType] = useState<any>(1);
  const [options, setOptions] = useState<any>([]);
  const [value, setValue] = useState('');
  const [range, setRange] = useState<DateRange | undefined>(undefined);

  useEffect(() => {
    let handleOptions;
    let defaults;
    switch (reportType) {
      case 1:
        handleOptions = salesOptions;
        defaults = 'sold-323';
        break;
      case 2:
        handleOptions = stocksOptions;
        defaults = 'available-323';
        break;
      default:
        handleOptions = customerOptions;
        defaults = 'new-user';
    }
    setOptions(handleOptions);
    setValue(defaults);
  }, [reportType]);

  const stockColumns = useMemo<ColumnDef<any, any>[]>(
    () => [
      { id: 'subCategory', header: 'Sub Category', cell: ({ row }) => row.original?.subCategory },
      { id: 'availableCount', header: 'Available Count', cell: ({ row }) => <span className="tabular-nums">{row.original?.availableCount}</span> },
    ],
    []
  );
  const customerColumns = useMemo<ColumnDef<any, any>[]>(
    () => [
      { id: 'name', header: 'Name', cell: ({ row }) => row.original?.name },
      { id: 'mobileNo', header: 'Mobile No.', cell: ({ row }) => row.original?.mobileNo },
    ],
    []
  );

  const columns = reportType === 3 ? customerColumns : stockColumns;
  const tableData = reportType === 3 ? customerData : data;

  return (
    <div className="mz h-full space-y-4 overflow-y-auto px-6 py-4">
      <PageHeader
        title="Reports"
        actions={
          <div className="flex flex-wrap items-center gap-2">
            <DateRangePicker value={range} onChange={setRange} disableFuture placeholder="From Date – To Date" />
            <Select defaultValue="customer">
              <SelectTrigger className="w-[130px]"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="customer">Customer</SelectItem>
                <SelectItem value="Oldest">Oldest</SelectItem>
              </SelectContent>
            </Select>
          </div>
        }
      />

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-1 border-b">
          {TABS.map((label, index) => {
            const typeId = index + 1;
            const active = reportType === typeId;
            return (
              <button
                key={label}
                type="button"
                onClick={() => setReportType(typeId)}
                className={cn(
                  'border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                  active ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'
                )}
              >
                {label}
              </button>
            );
          })}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Select defaultValue="Saree">
            <SelectTrigger className="w-[130px]"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="Saree">Saree</SelectItem>
              <SelectItem value="Tops">Tops</SelectItem>
            </SelectContent>
          </Select>
          <Select value={value} onValueChange={(v) => setValue(v)}>
            <SelectTrigger className="w-[220px]"><SelectValue /></SelectTrigger>
            <SelectContent>
              {(options || []).map((item: any) => (
                <SelectItem key={item?.value} value={item?.value}>{item?.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <DataTable columns={columns} data={tableData} />
    </div>
  );
};

export default Report;
